import { render } from "./EventsComponent.vue?vue&type=template&id=d520fe8a"
import script from "./EventsComponent.vue?vue&type=script&lang=js"
export * from "./EventsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__